/**
 * Dashboard chart palette.
 *
 * Recharts không đọc được `var(--color-…)` trực tiếp khi truyền vào prop
 * `fill` / `stroke` (nó hash hex để cache path). Helper dưới đây resolve
 * CSS var qua getComputedStyle 1 lần trên client để chart nhận hex thật.
 */

export const BRAND_TOKENS = [
  "--color-brand",
  "--color-brand-light",
  "--color-brand-dark",
  "--color-warning",
  "--color-success",
  "--color-info",
  "--color-purple",
  "--color-danger",
] as const;

const cache = new Map<string, string>();

export function readToken(name: string, fallback = "#8b6914"): string {
  if (typeof window === "undefined") return fallback;
  const cached = cache.get(name);
  if (cached) return cached;
  const v = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
  const resolved = v || fallback;
  cache.set(name, resolved);
  return resolved;
}

/** PIE_COLORS — match palette FE cũ (recharts dùng cycle). */
export function pieColors(): string[] {
  return [
    readToken("--color-brand", "#8b6914"),
    readToken("--color-warning", "#c9a96e"),
    readToken("--color-success", "#6b9e7a"),
    readToken("--color-info", "#7ba7c2"),
    readToken("--color-purple", "#a48bbe"),
    readToken("--color-danger", "#c17c74"),
  ];
}

/** Status colors map dùng cho pipeline / kanban chart. */
export function statusColor(status: string): string {
  switch (status) {
    case "done":
    case "completed":
      return readToken("--color-success", "#6b9e7a");
    case "cancelled":
    case "canceled":
      return readToken("--color-danger", "#c17c74");
    case "pending":
    case "new":
      return readToken("--color-info", "#7ba7c2");
    case "processing":
    case "shooting":
    case "retouch":
      return readToken("--color-warning", "#c9a96e");
    default:
      return readToken("--color-brand", "#8b6914");
  }
}
